module.exports = __webpack_public_path__ + "static/media/rightCloud.ff3c8c56.png";